import script from "./NextSteps.vue?vue&type=script&setup=true&lang=ts"
export * from "./NextSteps.vue?vue&type=script&setup=true&lang=ts"

import "./NextSteps.vue?vue&type=style&index=0&id=195c612c&lang=css"

const __exports__ = script;

export default __exports__